import React, { useEffect } from 'react';
import './psatencionm.css';
import { psatencionm } from '../../json/psatencionm';

const Psatencionm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa de Atención a Migrantes 2023</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El programa de atención al migrante favorece la condición social de las y los migrantes hidalguenses a través de la ejecución de acciones, procurando la atención en el retorno a sus localidades de origen y en su destino en el extranjero, a través de la reunificación familiar, mejoramiento de la infraestructura básica de sus localidades de origen, mejora de sus fuentes de ingresos, asistencia migratoria, inserción al mercado laboral y la organización comunitaria hidalguense en el extranjero y sus familias.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Coadyuvar a reducir las desigualdades y mejorar las condiciones de vida de la población migrante hidalguense y sus familias, a través de acciones igualitarias y sostenibles que permitan reducir los efectos negativos propios de la migración a fin de fortalecer su desarrollo integral en aspectos económicos, laborales, familiares, sociales, culturales y les permita el goce de sus derechos en sus lugares de origen, tránsito y destino.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Migrantes Hidalguenses en el exterior, en tránsito, retornados o repatriados, así como su familia.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                En los 84 Municipios del Estado de Hidalgo y los E.U.A.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Inclusión y Desarrollo<br />
                  </li>
                  <li>Dirección General de Atención al Migrante<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Mtra.Neyda Naranjo Baltazar<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 107 4358<br />                             

                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_Migrantes_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Benef_4oT_2023_Atn_Mig.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a>Beneficiarios 4° Trimestre</strong></h5>
                <p>
                </p>
                
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psatencionm;